export const integrationsDirectCdiGcpWifPrincipalAppGroupId =
  "/integrations/direct/cdi/gcp-wif-principal/:app_group_id";
